import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare var ga: Function;

if (environment.production) {
  enableProdMode();
  applyGA('UA-101485594-2');
} else {
  applyGA('UA-101485594-1');
}

platformBrowserDynamic().bootstrapModule(AppModule);


function applyGA(uaId: string) {
  (function (i, s, o, g, r, a?, m?) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * <any>new Date();
    a = s.createElement(o),
      m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

  ga('create', uaId, 'auto');  // <- add the UA-ID from your tracking code
}
